export const Periods = {
	LastWeek: 1,
	LastMonth: 2,
	Last3Months: 3,
	Last6Months: 4,
	Last12Months: 5,
	Custom: 6
}
